import React from 'react'

function Service2() {
    return (
        <div>
            <h1>Hello rajaService 2</h1>
        </div>
    )
}

export default Service2
